// 	现象原因
<template>
  <div id="containt" class="detail-wrap">
    <el-form ref="editForm" :model="tenant">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info" />
          现象原因
        </div>
        <div class="fr">
          <!--          <el-button icon="el-icon-brush" class="button-sty btn_color" @click="resetEvent">重置</el-button>-->
          <el-button type="warning" class="button-sty" icon="el-icon-search" @click="searchEvent">搜索</el-button>

        </div>
      </div>
      <div class="grid-height" style="display:flex;flex-direction: column;">
        <div>
          <div class="input_main">
            <div class="main">
              <el-form class="screen-box" title-width="92px" title-align="right" :data="formData"
                       @submit="searchEvent" @reset="searchEvent">
                <div class="main_item">

                  <el-form-item>
                    <div class="item_items">
                      <span>故障现象编码:</span>
                      <el-input v-model="formData.searchSymptomCode" placeholder="请输入故障现象编码"></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <div class="item_items">
                      <span>故障现象名称:</span>
                      <el-input v-model="formData.searchSymptomName" placeholder="请输入故障现象名称"></el-input>
                    </div>
                  </el-form-item>

                  <el-form-item>
                    <div class="item_items">
                      <span>故障原因编码:</span>
                      <el-input v-model="formData.searchReasonCode" placeholder="请输入故障原因编码"></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <div class="item_items">
                      <span>故障原因名称:</span>
                      <el-input v-model="formData.searchReasonName" placeholder="请输入故障原因名称"></el-input>
                    </div>
                  </el-form-item>


                  <!--                  <el-form-item>-->
                  <!--                    <div class="item_items">-->
                  <!--                      <span>故障原因编码:</span>-->
                  <!--                      <el-input v-model="formData.tableDataName2" placeholder="请输入故障原因编码"></el-input>-->
                  <!--                    </div>-->
                  <!--                  </el-form-item>-->
                  <!--                  <el-form-item>-->
                  <!--                    <div class="item_items">-->
                  <!--                      <span>故障原因名称:</span>-->
                  <!--                      <el-input v-model="formData.tableDataPer2" placeholder="请输入故障原因名称"></el-input>-->
                  <!--                    </div>-->
                  <!--                  </el-form-item>-->

                </div>
              </el-form>
            </div>
            <!-- <el-button type="primary" @click="doFilter">搜索</el-button> -->

          </div>
        </div>
        <!-- 左边------- 树型结构 -->
        <div style="display:flex;">
          <div class="left_tree">
            <div class="title1" style="margin-left: 10px;border-top: 1px solid #ededed;">全部故障</div>
            <div style="padding: 5px;
			    margin: 0px 8px;
			    height: 100vh;
			    border: 1px solid #ededed;">
              <div class="title"> <svg t="1676961094129" class="icon tree_icon" viewBox="0 0 1024 1024"
                                       version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2887" width="20" height="20">
                <path
                  d="M384 725.333333c0 21.333333 17.066667 38.4 38.4 42.666667H640v-42.666667c0-21.333333 17.066667-38.4 38.4-42.666666H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666666v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666667h-213.333333c-68.266667 0-123.733333-51.2-128-119.466666V341.333333H170.666667c-21.333333 0-38.4-17.066667-42.666667-38.4V128c0-25.6 17.066667-42.666667 42.666667-42.666667h341.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666667c0 25.6-17.066667 42.666667-42.666667 42.666666H384v128h256v-42.666666c0-21.333333 17.066667-38.4 38.4-42.666667H853.333333c25.6 0 42.666667 17.066667 42.666667 42.666667v170.666666c0 25.6-17.066667 42.666667-42.666667 42.666667h-170.666666c-25.6 0-42.666667-17.066667-42.666667-42.666667v-42.666666H384v170.666666z m426.666667 42.666667h-85.333334v85.333333h85.333334v-85.333333z m0-298.666667h-85.333334v85.333334h85.333334v-85.333334z m-341.333334-298.666666H213.333333v85.333333h256V170.666667z"
                  fill="#1296db" p-id="2888"></path>
              </svg>

                <span>商品分类</span>
              </div>
              <el-input placeholder="关键字过滤" v-model="filterText">
              </el-input>

              <el-tree class="tree-line" :data="data" lazy
                       :load="loadChildNode" :props="defaultProps" @node-click="handleNodeClick"
                       :filter-node-method="filterNode" ref="tree"
                       v-if="isRouterAlive"
              >
              </el-tree>
            </div>
          </div>
          <!-- 中间边表结构 -->
          <div class="table_main"  style=" height: calc(100vh - 137px);">
            <div class="title1">故障现象</div>
            <vxe-grid :stripe="true" border="default"  show-overflow height="100%" ref="table-m1"
                      v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle"
                      @current-change="currentHandler"
            >
              <template #form>
              </template>
              <!-- 分页器 -->
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
            </vxe-grid>
          </div>
          <!-- 右边表结构 -->
          <div class="table_main" style=" height: calc(100vh - 141px);">
            <div class="title1">故障原因</div>
            <vxe-grid :stripe="true" border="default"  show-overflow height="100%" ref="table-m2"
                      v-bind="vxeOption2" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">
              <template #form>
              </template>
              <!-- 分页器 -->
              <template #pager>

                <el-button type="primary" class="button-sty btn_zdy2"  @click="showPreconditionDialogClick">
                  <i class="el-icon-plus"></i>
                  增加故障原因</el-button>
                <!-- <div class="btn_dialog"><el-button ><i class="el-icon-plus"></i>增加配件明细</el-button></div> -->
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>

    </el-form>
    <preconditionDialog v-if="showPreconditionDialog"
                        @confirm="commitSelectedRow"
                        :visiable.sync="showPreconditionDialog"
                        :symptomId="symptomId"
                        multi="true"
    />
  </div>
</template>

<script>
import { tableOption } from '@/const/crud/admin/tenant';
import { initVxeTable } from '@/const/crud/admin/table';
import { initVxeTableNoTotal } from '@/const/crud/admin/tableNoTotal';
import pager from '@/components/pager/index.vue';
import {fetchTree} from "@/api/admin/type_tree";
import preconditionDialog from '@/views/dialogCommon/checkboxFaultReasonDialog.vue';
export default {
  components: { pager,  preconditionDialog, },
  data() {
    return {
      total: 0,
      getFaultSymptomListPageUrl: '/basic/basFaultSymptom/getListPage',
      getFaultReasonListPageUrl: '/basic/basFaultReason/getList',
      deleteRowUrl: '/basic/basFaultReasonMapping/delete',
      bindDataUrl: '/basic/basFaultReasonMapping/add',

      showPreconditionDialog: false,
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        bigCategoryId: '',
        smallCategoryId: '',
        symptomCode: '',
        symptomName: '',
        reasonCode: null,
        reasonName: null
      },
      formData: {
        searchSymptomName: '',
        searchSymptomCode: '',
        searchReasonCode: null,
        searchReasonName: null
      },
      pageSizes: [10, 20, 100],
      showEdit: false,
      symptomId: '',
      filterText: '',
      data: [],
      columns: [
        { type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },
        { title: '故障现象编码', field: 'symptomCode', width: 150, },
        { title: '故障现象名称', field: 'symptomName', width: 150, },
        { title: '产品大类', field: 'bigCategoryName', width: 150, },
        { title: '产品小类', field: 'smallCategoryName', width: 150, },
        // { title: '上级原因', field: 'parent_id', width: 150, },
        { title: '启用', field: 'usable', width: 150, slots: {
            default: ({ row }) => {
              if (row.usable == 0) {
                return [
                  <div>
                    <span>禁用</span>
                  </div>
                ];
              } else if (row.usable == 1) {
                return [
                  <div>
                    <span>启用</span>
                  </div>
                ];
              }
            }
          }
        },
        { field: 'createTime', title: '创建时间', width: 150 },
        { title: '创建人', field: 'createBy', width: 150, },
      ],
      columns1: [
        { type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left' },
        {
          title: '故障原因编码',
          field: 'reasonCode',
          width: 100,
          fixed: 'left'
        },
        {
          title: '故障原因名称',
          field: 'reasonName',
          width: 100,
        },
        {
          title: '产品大类',
          field: 'bigCategoryName',
          width: 100,
        },
        {
          title: '产品小类',
          field: 'smallCategoryName',
          width: 100,
        },
        {
          title: '状态',
          field: 'usable',
          width: 80,
          slots: {
            default: ({ row }) => {
              if (row.usable == 0) {
                return [
                  <div>
                    <span>禁用</span>
                  </div>
                ];
              } else if (row.usable == 1) {
                return [
                  <div>
                    <span>启用</span>
                  </div>
                ];
              }
            }
          }
        },
        { width: 47, fixed: 'right', title: '', sortable: false, slots: {
            default: ({ row }) => {
              return [
                <div>
                  <a
                    href="javascript:void(0);"
                    class="a-link"
                    onclick={() => {
                      this.deleteRow(row.id);
                    }}
                  >
                    <el-tooltip enterable={false} effect="dark" content="删除" placement="top" popper-class="tooltip-skin">
                      <i class="el-icon-delete" />
                    </el-tooltip>
                  </a>
                </div>
              ];
            }
          }
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      //以上树形
      activeName: 'second',
      dataId: 0,
      vxeOption: {},
      vxeOption2: {},
      isRouterAlive: true
    };
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    showPreconditionDialog(newVal) {
      if (!newVal) {
        this.getFaultReasonTableData()
      }
    }
  },
  computed: {
    getDataParams() {
      return {symptomId: this.symptomId}
    }
  },
  methods: {
    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    flushed2() {
      this.$refs['table-m2'].commitProxy('reload');
    },

    // 树形控件加载节点数据
    loadChildNode(node, resolve) {
      fetchTree({
        parentId: node.data.id,
        categoryType: 1
      }).then(({data}) => {
        resolve(
          data.data.map(item => {
            return {
              label: item.categoryName,
              id: item.id,
              leaf: Number(item.isChild) == 1 ? false : true,
            }
          })
        )
      })
    },

    // 点击的树形节点
    handleNodeClick(node, data) {
      console.log(data,"点击data的值");
      let id = data.data.id ;
      console.log(id, "点击id的值");
      if(data.level === 1){
        this.requestParam.bigCategoryId = id;
        this.requestParam.smallCategoryId = '';
      }else{
        this.requestParam.smallCategoryId = id;
      }

      this.getFaultSymptomTableData();
    },


    // 加载故障现象table数据
    getFaultSymptomTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: this.getFaultSymptomListPageUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.columns
      };
      let initVxeTable1 = initVxeTable(tableOption);
      initVxeTable1.rowConfig = {isCurrent: true}
      this.vxeOption = initVxeTable1;
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },
    // 选中关联产品数据回传提交
    commitSelectedRow(data) {
      this.$http({
        url: this.bindDataUrl,
        method: 'post',
        data: {
          symptomId: this.symptomId,
          reasonIds:  data.map(item => item.id),
        }
      }).then(res => {
        this.$message.success("添加成功")
        this.flushed1()
      })

    },
    commitRow() {
      if (this.checkedArray.length === 0) {
        this.$message.warning('请先选中故障原因')
      } else {
        this.$http({
          url: this.bindDataUrl,
          method: 'post',
          data: {
            symptomId: this.symptomId,
            reasonIds: this.checkedArray
          }
        }).then(res => {
          this.$message.success("添加成功")
          this.flushed()
        })
      }
    },
    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.symptomId = ''
      this.flushed2()
      this.getFaultSymptomTableData();
    },

    // 加载故障原因table数据
    getFaultReasonTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m2',
        path: this.getFaultReasonListPageUrl,
        // param: {symptomId: this.symptomId},
        method: 'post',
        columns: this.columns1
      };
      this.vxeOption2 = initVxeTableNoTotal(tableOption);
      this.flushed2()
    },

    currentHandler({row}) {
      console.log(row.id)
      this.symptomId = row.id
      this.getFaultReasonTableData()
    },


    showPreconditionDialogClick() {
      if (this.symptomId !== '') {
        this.showPreconditionDialog = true
      } else {
        this.$message.warning('请先选中故障现象')
      }
    },


    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },


    // 搜索
    searchEvent() {
      this.requestParam.symptomCode = this.formData.searchSymptomCode
      this.requestParam.symptomName = this.formData.searchSymptomName
      this.requestParam.reasonCode = this.formData.searchReasonCode
      this.requestParam.reasonName = this.formData.searchReasonName
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.symptomId = ''
      this.flushed()
      this.flushed2()
    },

    // 重置
    resetEvent() {
      this.formData = {}
      this.requestParam.symptomCode = ''
      this.requestParam.symptomName = ''
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.requestParam.bigCategoryId = ''
      this.requestParam.smallCategoryId = ''
      this.$refs.pager.reset()  // 重置分页器
      this.symptomId = ''
      this.flushed()
      this.flushed2()
      this.reload()
    },

    reload(){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    },


    deleteRow(id) {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        let ids = []
        ids.push(id)
        this.$http({
          url: this.deleteRowUrl,
          method: 'post',
          data: {
            symptomId: this.symptomId,
            reasonIds: ids
          }
        }).then(res => {
          this.$message.success('删除成功')
          this.flushed2()
        })
      })
    },

  }
};
</script>
<style lang="scss" scoped>
#containt {
  overflow-y: hidden;
}

::v-deep .grid-height {
  height: calc(100vh - 47px) !important;
}


.table_main {
  // padding-top: 5px;
  // padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(50% - 108px);
  border-bottom: none;

  .el-pagination {

    padding: 2px;

  }
}

.title1 {
  text-align: center;
  background-color: #bad5ef;
;
  margin-bottom: 10px;
  padding: 5px;
  font-weight: 600;
  color: #666;

}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    >span {
      position: relative;
      left: 4px;
      top: -3px;

    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式 记得在树里加class="tree-line"
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  &>.el-tree-node::after {
    border-top: none;
  }

  &>.el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }


}



.detail-wrap .d-header {
  height: 34px;
  line-height: 34px;
  margin: 7px 0px 0px 0px;
  padding: 0px 10px 0 14px;
  font-size: 13px;
  overflow: hidden;
  background-color: #FFF;

  .btn_color {
    color: #2a6494;
    border: solid 1px rgba(42, 100, 148, 0.4);

  }

  .btn_color:hover {
    color: #357fbc;
    border-color: #357fbc;
    background-color: #ffffff;
  }
}

.detail-wrap .d-header .fl>i {
  color: #2a6494;
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
  margin-bottom: 1px;
  font-size: 14px;
  font-size: 14px;
}

.input_main {
  margin-left: 10px;

  .main {
    display: flex;
    flex-direction: column;
    background-color: #fff;

    .main_item {

      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      background-color: #F4F6FA;
      padding-top: 8px;
      margin: 0px 0px 5px 0px;
      border-top: solid 1px #E9E9E9;
      border-bottom: solid 1px #E9E9E9;

      .item_items {
        display: flex;
        margin-bottom: 8px;

        span {
          width: 112px;
          font-weight: 400;
          text-align: right;
          line-height: 28px;
          font-size: 12px;
          position: relative;
          padding: 0 10px 0 4px;
          color: rgba(86, 86, 86, 0.96);
        }

        .el-input {
          width: 60%
        }
      }
    }
  }

}
// .btn_dialog{
//     height: 48px;
//     margin-top: 8px;
//     margin-left: 10px;
// }
.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-bottom: 5px;
  margin-left: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}
.btn_zdy2:hover {
  color: #2A6494 !important;
  border: 1px solid #2A6494 !important;
}
::v-deep .el-dialog{

  margin-top: 3% !important;

}
::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
</style>
